import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const LOGIN_URL =
  "https://522gqh3w18.execute-api.ap-south-1.amazonaws.com/Prod/Auth/Login";
const SIGNUP_URL =
  "https://522gqh3w18.execute-api.ap-south-1.amazonaws.com/Prod/Auth/Signup";

function Header() {
  const navigate = useNavigate();
  const [hasToken, setHasToken] = useState(!!localStorage.getItem("SLNToken"));
  const [mode, setMode] = useState("login");
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const sync = () => setHasToken(!!localStorage.getItem("SLNToken"));
    sync();
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);

  // ── Login state ──
  const [phone, setPhone] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginErr, setLoginErr] = useState("");

  // ── Register state ──
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    referralCode: "",
  });
  const [regLoading, setRegLoading] = useState(false);
  const [regErr, setRegErr] = useState("");

  const switchMode = (m) => {
    setMode(m);
    setLoginErr("");
    setRegErr("");
    setPhone("");
    setForm({ name: "", email: "", phone: "", referralCode: "" });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginErr("");
    const digits = phone.replace(/\D/g, "");
    if (digits.length !== 10) {
      setLoginErr("Mobile number must be 10 digits.");
      return;
    }

    setLoginLoading(true);
    try {
      const res = await fetch(LOGIN_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: digits }),
      });
      const text = await res.text();
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch {
        data = { message: text };
      }
      if (!res.ok)
        throw new Error(
          data?.message || data?.error || `Login failed (HTTP ${res.status})`,
        );

      const modalEl = document.getElementById("loginModal");
      if (modalEl && window.bootstrap?.Modal) {
        window.bootstrap.Modal.getInstance(modalEl)?.hide();
      }
      navigate("/otp", { state: { phone: digits } });
    } catch (error) {
      setLoginErr(error?.message || "Something went wrong.");
    } finally {
      setLoginLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setRegErr("");
    const digits = form.phone.replace(/\D/g, "");
    if (!form.name.trim()) {
      setRegErr("Full Name is required.");
      return;
    }
    if (digits.length !== 10) {
      setRegErr("Phone number must be 10 digits.");
      return;
    }

    setRegLoading(true);
    try {
      const res = await fetch(SIGNUP_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          phone: digits,
          name: form.name.trim(),
          email: form.email.trim(),
          profilePic: "",
          referralCode: form.referralCode || "",
          slnAccess: false,
        }),
      });
      const text = await res.text();
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch {
        data = { message: text };
      }
      if (!res.ok)
        throw new Error(
          data?.message || data?.error || `Signup failed (HTTP ${res.status})`,
        );

      const modalEl = document.getElementById("loginModal");
      if (modalEl && window.bootstrap?.Modal) {
        window.bootstrap.Modal.getInstance(modalEl)?.hide();
      }
      navigate("/otp", { state: { phone: digits } });
    } catch (err) {
      setRegErr(err?.message || "Something went wrong.");
    } finally {
      setRegLoading(false);
    }
  };

  const showLoginModal = () => {
    switchMode("login");
    const modal = document.getElementById("loginModal");
    if (modal && window.bootstrap?.Modal) {
      new window.bootstrap.Modal(modal).show();
    }
  };

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          "https://522gqh3w18.execute-api.ap-south-1.amazonaws.com/Prod/Courses/GetAllCourses?limit=8&category",
        );
        if (!res.ok) throw new Error("Failed to fetch course");
        const data = await res.json();

        setCategory(data?.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategory();
  }, []);

  return (
    <>
      {/* ── top bar & navbar unchanged ── */}
      {/* <section className="light-yellow-bg">
        <div className="container py-1">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-end align-items-center">
              <p className="fst-italic fs-5 lh-1 m-0 me-6 text-dark me-3">
                <i className="bi bi-telephone me-2"></i> +91 6386191243
              </p>
              <p className="fst-italic fs-5 lh-1 m-0 me-6 text-dark d-lg-block d-none">
                <i className="bi bi-whatsapp me-2"></i> +91 9506069151
              </p>
            </div>
            <div className="d-flex justify-content-end align-items-center">
              <p className="fst-italic fs-6 lh-sm m-0 me-6 text-dark d-lg-block d-none">
                Registered NSE Authorised Person
                <br />
                (AP Code: <u>AP2486037784</u>) under{" "}
                <u>Choice Equity Broking Pvt. Ltd</u>
              </p>
              <img
                src="/assets/images/nse.png"
                height="35"
                className="bg-white px-3 py-2 rounded-pill me-1"
              />
              <img
                src="/assets/images/iso.png"
                height="35"
                className="bg-white px-2 py-2 rounded-pill me-1"
              />
              <img
                src="/assets/images/startup-india.png"
                height="35"
                className="bg-white rounded-pill"
              />
            </div>
          </div>
        </div>
      </section> */}

      {/* ── Ticker Banner ─────────────────────────────────────────────────── */}

      <div
        className="d-flex justify-content-center align-items-center position-relative overflow-hidden"
        style={{
          background:
            "linear-gradient(90deg, #1a0800 0%, #2e1200 30%, #3a1800 50%, #2e1200 70%, #1a0800 100%)",
          height: 44,
        }}
      >
        <div className="container d-flex justify-content-between align-items-center position-relative overflow-hidden">
          <div className="d-flex align-items-center">
            {/* shimmer sweep */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "60%",
                height: "100%",
                background:
                  "linear-gradient(90deg,transparent,rgba(255,160,30,0.07),transparent)",
                pointerEvents: "none",
              }}
            />

            {/* Verified tag */}
            <span
              style={{
                background: "linear-gradient(135deg,#FF8C00,#E06400)",
                borderRadius: 3,
                padding: "2px 10px",
                fontSize: 9.5,
                fontWeight: 800,
                letterSpacing: "0.14em",
                color: "#1a0800",
                textTransform: "uppercase",
                marginRight: 18,
                flexShrink: 0,
                boxShadow: "0 0 12px rgba(255,140,0,0.35)",
              }}
            >
              ✦ Verified
            </span>

            {[
              "SEBI-Trained Mentor",
              "ISO Certified Institute",
              "Startup India Recognised",
            ].map((label, i) => (
              <div
                key={label}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 7,
                  padding: "0 16px",
                  whiteSpace: "nowrap",
                }}
              >
                {i > 0 && (
                  <div
                    style={{
                      width: 1,
                      height: 18,
                      background:
                        "linear-gradient(to bottom,transparent,rgba(255,140,0,0.35),transparent)",
                      flexShrink: 0,
                      marginRight: 16,
                    }}
                  />
                )}
                <span
                  style={{
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    border: "1.5px solid rgba(255,140,0,0.5)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    background: "rgba(255,140,0,0.1)",
                  }}
                >
                  <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <path
                      d="M1.5 4L3.2 5.8L6.5 2.2"
                      stroke="#FF8C00"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 600,
                    letterSpacing: "0.05em",
                    color: "#FF8C00",
                  }}
                >
                  {label}
                </span>
              </div>
            ))}
          </div>

          <div className="d-flex justify-content-end align-items-center">
            <img
              src="/assets/images/nse.png"
              height="35"
              className="bg-white px-3 py-2 rounded-pill me-1"
            />
            <img
              src="/assets/images/iso.png"
              height="35"
              className="bg-white px-2 py-2 rounded-pill me-1"
            />
            <img
              src="/assets/images/startup-india.png"
              height="35"
              className="bg-white rounded-pill"
            />
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg py-0 px-0 my-header-bg sticky-top z-5">
        <div className="container">
          <div className="d-flex align-items-center">
            <button
              className="navbar-toggler collapsed me-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-default"
              aria-controls="navbar-default"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-bar top-bar mt-0"></span>
              <span className="icon-bar middle-bar"></span>
              <span className="icon-bar bottom-bar"></span>
            </button>
            <Link to="/">
              <img
                src="/assets/images/logo.png"
                className="d-lg-none d-block"
                width="50"
              />
              <img
                src="/assets/images/logo.png"
                width="50"
                className="me-5 d-lg-block d-none"
              />
            </Link>
          </div>

          <div className="ms-auto d-flex align-items-center order-lg-3">
            <div className="d-flex align-items-center">
              <div className="d-flex gap-1 align-items-center justify-content-end me-lg-5 me-2">
                <a
                  href="https://www.facebook.com/profile.php?id=61586179350665"
                  target="_blank"
                  className="d-lg-block d-none"
                >
                  <img src="/assets/images/facebook.png" width="30" />
                </a>
                <img
                  src="/assets/images/instagram.png"
                  width="30"
                  className="d-lg-block d-none"
                />
                <a
                  href="https://x.com/AcademySln64983"
                  target="_blank"
                  className="d-lg-block d-none"
                >
                  <img src="/assets/images/x.png" width="30" />
                </a>
                <a
                  href="https://www.youtube.com/@SLNAcademyOfficial"
                  target="_blank"
                >
                  <img src="/assets/images/youtube.png" width="30" />
                </a>
              </div>

              {hasToken ? (
                <Link
                  to="/cart"
                  className="btn btn-icon btn-success rounded-circle d-none d-md-inline-flex ms-2"
                >
                  <i className="bi bi-cart-dash-fill fs-4 align-middle"></i>
                </Link>
              ) : (
                <a
                  href="tel:+916386191243"
                  className="btn btn-icon btn-success rounded-circle d-none d-md-inline-flex ms-2"
                >
                  <i className="bi bi-telephone-fill fs-4 align-middle"></i>
                </a>
              )}

              <div className="header-btn-height ms-1">
                <div
                  className="cursor-pointer bg-gradient-blue text-white fw-normal rounded-pill px-3 h-100 d-flex align-items-center"
                  onClick={() => {
                    if (hasToken) {
                      navigate("/dashboard");
                    } else {
                      showLoginModal();
                    }
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="fs-7 d-flex align-items-center">
                      <i className="bi bi-person-circle me-2 fs-3"></i>
                      {hasToken ? "My Account" : "Login / Create Account"}
                    </div>
                    <i
                      className={`bi fs-5 ms-5 ${hasToken ? "bi-chevron-right" : "bi-chevron-down"}`}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="collapse navbar-collapse" id="navbar-default">
            <ul className="navbar-nav mt-3 mt-lg-0">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About Us
                </Link>
              </li>
              <li className="nav-item dropdown">
                <Link className="nav-link dropdown-toggle">Gallery</Link>
                <ul className="dropdown-menu">
                  <li>
                    <a href="#" className="dropdown-item">
                      Image Gallery
                    </a>
                  </li>
                  <li>
                    <a href="#" className="dropdown-item">
                      Video Gallery
                    </a>
                  </li>
                  <li>
                    <a href="#" className="dropdown-item">
                      SLN Trader Gallery
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <Link className="nav-link dropdown-toggle">Courses</Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link to={`/category/`} className="dropdown-item">
                      All Courses
                    </Link>
                  </li>
                  {category?.map((item, index) => (
                    <li key={index}>
                      <Link
                        to={`/category/${item?.category}`}
                        className="dropdown-item"
                      >
                        {item?.category}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/sln-scan">
                  SLN Scan
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* ── floating buttons ── */}
      <div className="d-flex justify-content-end position-relative">
        <div className="position-fixed z-5 top-20 d-flex flex-column align-items-end width-fit-content">
          <div className="btn btn-white shadow rounded-end-0 rounded-start-pill ps-2 pe-3 mb-2">
            <a
              href="https://api.whatsapp.com/send?phone=916386191243&text=Hi"
              target="_blank"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/3992/3992601.png"
                width="35"
                className="rounded-5"
              />
            </a>
          </div>
          <div className="btn btn-white shadow rounded-end-0 rounded-start-pill ps-2 pe-3">
            <a href="tel:+916386191243" target="_blank">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3178/3178496.png"
                width="35"
                className="rounded-5"
              />
            </a>
          </div>
        </div>
      </div>

      {/* ── Login / Register Modal ── */}
      <div
        className="modal fade"
        id="loginModal"
        tabIndex="-1"
        aria-labelledby="loginModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-5 py-5">
            <div className="row">
              {/* left image */}
              <div className="col-6">
                <img
                  src="/assets/images/3.jpg"
                  className="w-100 object-fit-cover ms-n8 rounded-5"
                  height="400"
                />
              </div>

              {/* right form */}
              <div className="col-6 pe-2 ps-lg-2 ms-n6 d-flex align-items-center">
                <div className="w-100">
                  {mode === "login" && (
                    <>
                      <div className="d-flex flex-column gap-1 mb-3">
                        <h3 className="mb-0 fw-bold text-dark lh-1">Sign In</h3>
                        <span className="text-dark lh-1">
                          New here?{" "}
                          <span
                            className="text-primary"
                            style={{ cursor: "pointer" }}
                            onClick={() => switchMode("register")}
                          >
                            Create an account
                          </span>
                        </span>
                      </div>

                      <form className="needs-validation" onSubmit={handleLogin}>
                        <div className="mb-3">
                          <label className="label-text text-dark mb-1 ms-3">
                            WhatsApp Mobile No.{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control ps-3 normal-text ls-sm text-dark bg-transparent dark-border rounded-3"
                            placeholder="Enter Mobile No"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            disabled={loginLoading}
                            required
                          />
                        </div>
                        {loginErr && (
                          <div className="alert alert-danger py-2">
                            {loginErr}
                          </div>
                        )}
                        <button
                          type="submit"
                          className="btn btn-warning border-0 fw-medium ls-sm text-white rounded-pill px-6 btn-md w-100"
                          disabled={loginLoading}
                        >
                          {loginLoading ? "Sending OTP..." : "Continue"}
                        </button>
                      </form>
                    </>
                  )}

                  {/* ── Register form ── */}
                  {mode === "register" && (
                    <>
                      <div className="d-flex flex-column gap-1 mb-3">
                        <h3 className="mb-0 fw-bold text-dark lh-1">
                          Create Account
                        </h3>
                        <span className="text-dark lh-1">
                          Already registered?{" "}
                          <span
                            className="text-primary"
                            style={{ cursor: "pointer" }}
                            onClick={() => switchMode("login")}
                          >
                            Sign In
                          </span>
                        </span>
                      </div>

                      <form
                        className="needs-validation"
                        onSubmit={handleRegister}
                      >
                        <div className="mb-2">
                          <label className="label-text text-dark mb-1 ms-3">
                            Full Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control ps-3 normal-text text-dark bg-transparent dark-border rounded-3"
                            placeholder="Enter Full Name"
                            value={form.name}
                            onChange={(e) =>
                              setForm((p) => ({ ...p, name: e.target.value }))
                            }
                            disabled={regLoading}
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label className="label-text text-dark mb-1 ms-3">
                            WhatsApp Mobile No{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control ps-3 normal-text text-dark bg-transparent dark-border rounded-3"
                            placeholder="Enter Phone No"
                            value={form.phone}
                            onChange={(e) =>
                              setForm((p) => ({ ...p, phone: e.target.value }))
                            }
                            disabled={regLoading}
                            required
                          />
                        </div>
                        {regErr && (
                          <div className="alert alert-danger py-2">
                            {regErr}
                          </div>
                        )}
                        <button
                          type="submit"
                          className="btn btn-warning border-0 fw-medium ls-sm text-white rounded-pill px-6 btn-md w-100"
                          disabled={regLoading}
                        >
                          {regLoading ? "Creating..." : "Continue"}
                        </button>
                      </form>
                    </>
                  )}

                  <div className="mt-3 text-center">
                    <a className="fs-5 lh-1" href="/contact">
                      Need Help? Contact Us
                    </a>
                    <p className="lh-sm text-dark mt-2">
                      By proceeding, you agree to SLN Academy Privacy Policy,
                      User Agreement and T&Cs
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
